module.exports = __webpack_public_path__ + "img/header_payment_proof.c53ed737.png";